import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = "https://tulithevlogger.com/api/orders";

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [items, setItems] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [loading, setLoading] = useState(false);

  const [searchOrderId, setSearchOrderId] = useState("");
const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");

  const token = localStorage.getItem("token");

  // =========================
  // LOAD ORDERS
  // =========================
  const loadOrders = useCallback(async () => {
    try {
      setLoading(true);

      const res = await axios.get(API, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const data = res.data.data || res.data || [];

      setOrders(data);

    } catch (err) {

      console.error("LOAD ORDERS ERROR:", err);

    } finally {

      setLoading(false);
    }

  }, [token]);

  // =========================
  // INITIAL LOAD
  // =========================
  useEffect(() => {
    loadOrders();
  }, [loadOrders]);

  // =========================
  // VIEW ITEMS
  // =========================
  const viewItems = async (order) => {
  try {

    const orderId = order.id || order.Id;

    if (!orderId) {
      alert("Order ID missing");
      return;
    }

    setSelectedOrder(order);

    const res = await axios.get(
      `https://tulithevlogger.com/api/orders/${orderId}/items`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    console.log("ORDER ITEMS RESPONSE:", res.data);

    const itemsData =
      Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data.data)
        ? res.data.data
        : Array.isArray(res.data.items)
        ? res.data.items
        : [];

    setItems(itemsData);

  } catch (err) {

    console.error("VIEW ITEMS ERROR:", err);

    setItems([]);

    alert("Failed to load order items");
  }
};

  // =========================
  // UPDATE STATUS
  // =========================
  const updateStatus = async (id, status) => {
    try {

      await axios.put(
        `${API}/${id}/status`,
        { status },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setOrders(prev =>
        prev.map(o =>
          o.id === id
            ? { ...o, status }
            : o
        )
      );

    } catch (err) {

      console.error("STATUS UPDATE ERROR:", err);

      alert("Status update failed");
    }
  };
const filteredOrders = orders.filter((o) => {

  const orderMatch =
    searchOrderId === "" ||
    String(o.id)
      .toLowerCase()
      .includes(searchOrderId.toLowerCase()) ||
    String(o.orderid || "")
      .toLowerCase()
      .includes(searchOrderId.toLowerCase());

  const orderDate = o.createdat
    ? new Date(o.createdat)
    : null;

  let dateMatch = true;

  if (fromDate && orderDate) {
    dateMatch =
      dateMatch &&
      orderDate >= new Date(fromDate);
  }

  if (toDate && orderDate) {

    const endDate = new Date(toDate);
    endDate.setHours(23, 59, 59, 999);

    dateMatch =
      dateMatch &&
      orderDate <= endDate;
  }

  return orderMatch && dateMatch;
});
  // =========================
  // UI
  // =========================
  return (
    <div style={styles.page}>

      <div style={styles.header}>
        <h2 style={styles.title}>📦 Order Management</h2>
      </div>

      {/* TABLE */}
<div style={styles.searchBar}>

  <input
    type="text"
    placeholder="Search Order ID"
    value={searchOrderId}
    onChange={(e) =>
      setSearchOrderId(e.target.value)
    }
    style={styles.input}
  />

  <input
    type="date"
    value={fromDate}
    onChange={(e) =>
      setFromDate(e.target.value)
    }
    style={styles.input}
  />

  <input
    type="date"
    value={toDate}
    onChange={(e) =>
      setToDate(e.target.value)
    }
    style={styles.input}
  />

</div>
      <div style={styles.card}>

        <table style={styles.table}>

          <thead>

            <tr>

              <th style={styles.th}>Order ID</th>

              <th style={styles.th}>Customer</th>

              <th style={styles.th}>Email</th>

              <th style={styles.th}>Address</th>

              <th style={styles.th}>Status</th>
              <th style={styles.th}>Bill Amount</th>
              

              <th style={styles.th}>Date</th>

              <th style={styles.th}>Actions</th>

            </tr>

          </thead>

          <tbody>

            {loading ? (

              <tr>
                <td colSpan="7" style={styles.empty}>
                  Loading...
                </td>
              </tr>

            ) : orders.length === 0 ? (

              <tr>
                <td colSpan="7" style={styles.empty}>
                  No orders found
                </td>
              </tr>

            ) : (

              filteredOrders.map((o) => (

                <tr key={o.id}>

                  <td style={styles.td}>
                    #{o.id}
                  </td>

                  <td style={styles.td}>
                    {o.name}
                  </td>

                  <td style={styles.td}>
                    {o.email}
                  </td>

                  <td style={styles.td}>
                    {o.address}
                  </td>

                  <td style={styles.td}>

                    <select
                      value={o.status}
                      onChange={(e) =>
                        updateStatus(o.id, e.target.value)
                      }
                      style={styles.select}
                    >
                      <option value="Pending">
                        Pending
                      </option>

                      <option value="Shipped">
                        Shipped
                      </option>

                      <option value="Delivered">
                        Delivered
                      </option>

                    </select>

                  </td>

                  <td style={styles.td}>
                  ₹{Number(o.totalamount || 0).toFixed(2)}
                </td>

                <td style={styles.td}>
                {o.createdat
                  ? new Date(o.createdat).toLocaleDateString("en-GB")
                  : "-"}
              </td>

                  <td style={styles.td}>

                    <button
                      style={styles.viewBtn}
                      onClick={() => viewItems(o)}
                    >
                      View Items
                    </button>

                  </td>

                </tr>

              ))
            )}

          </tbody>

        </table>

      </div>

      {/* MODAL */}

      {selectedOrder && (

        <div style={styles.overlay}>

          <div style={styles.modal}>

            <div style={styles.modalHeader}>

              <h3>
                Order #{selectedOrder.id}
              </h3>

              <button
                style={styles.closeBtn}
                onClick={() => setSelectedOrder(null)}
              >
                ✕
              </button>

            </div>

            <table style={styles.modalTable}>

              <thead>

                <tr>

                  <th style={styles.th}>Product</th>

                  <th style={styles.th}>Crt</th>

                  <th style={styles.th}>Price</th>

                  <th style={styles.th}>Total</th>

                </tr>

              </thead>

              <tbody>

                {items.length === 0 ? (

                  <tr>
                    <td colSpan="4" style={styles.empty}>
                      No items found
                    </td>
                  </tr>

                ) : (

                  items.map((item, index) => (

                    <tr key={`${item.productid}-${index}`}>

                      <td style={styles.td}>
                        {item.name}
                      </td>

                      <td style={styles.td}>
                        {item.quantity}
                      </td>

                      <td style={styles.td}>
                        ₹{Number(item.price || 0).toFixed(2)}
                      </td>

                      <td style={styles.td}>
                        ₹{(
                          Number(item.quantity || 0) *
                          Number(item.price || 0)
                        ).toFixed(2)}
                      </td>

                    </tr>

                  ))
                )}

              </tbody>

            </table>

          </div>

        </div>
      )}

    </div>
  );
};

export default AdminOrders;

// =========================
// STYLES
// =========================

const styles = {

  page: {
    padding: 20,
    background: "#f4f6f9",
    minHeight: "100vh"
  },

  header: {
    marginBottom: 20
  },

  title: {
    margin: 0,
    fontSize: 28
  },

  card: {
    background: "#fff",
    borderRadius: 10,
    overflow: "hidden",
    border: "1px solid #ddd"
  },

  table: {
    width: "100%",
    borderCollapse: "collapse"
  },

  th: {
    background: "#f8f9fa",
    border: "1px solid #ddd",
    padding: 12,
    textAlign: "left",
    fontSize: 14
  },

  td: {
    border: "1px solid #ddd",
    padding: 12,
    fontSize: 14
  },

  empty: {
    textAlign: "center",
    padding: 30
  },

  select: {
    padding: 6,
    borderRadius: 6,
    border: "1px solid #ccc"
  },

  viewBtn: {
    background: "#007bff",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: 6,
    cursor: "pointer"
  },

  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 999
  },

  modal: {
    width: "70%",
    background: "#fff",
    borderRadius: 10,
    padding: 20
  },

  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20
  },

  closeBtn: {
    background: "red",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: 6,
    cursor: "pointer"
  },

  modalTable: {
    width: "100%",
    borderCollapse: "collapse"
  },

  searchBar: {
  display: "flex",
  gap: 10,
  flexWrap: "wrap",
  marginBottom: 20
},

input: {
  padding: 10,
  border: "1px solid #ddd",
  borderRadius: 6,
  minWidth: 180
},
};